/* eslint-disable no-param-reassign */
/* eslint-disable no-debugger */
import type { ReduxCompatibleReducer } from 'redux-actions'
import { handleAction } from 'redux-actions'
import { toPascal, toCamel } from '../_utils/case'
import { buildActions } from '../actions'

import type { EasyKeys, EasySetKeys, EasyStates, EasyUpperKeys } from '../States'

type ReducerKVs = { [index in EasyKeys]?: ReduxCompatibleReducer<any, any> }

function unitReducer<T extends EasyStates, K extends keyof T>(source: T, key: K, _value?: T[K]): ReduxCompatibleReducer<any, any> {
  const camel = toCamel(`set_${toPascal(key as string)}`) as EasySetKeys
  const actions = buildActions<T>(source)
  return handleAction(
    actions[camel],
    (state, action) => {
      const { payload } = action
      if (Object.prototype.toString.call(payload) === '[object Object]') {
        return { ...state, ...payload }
      }
      return payload
    },
    source[key]
  )
}

export function buildReducers<T extends EasyStates>(obj: T): ReducerKVs {
  const arr = Object.keys(obj) as EasyKeys[]
  return arr.reduce((sum: ReducerKVs, key) => {
    sum[key] = unitReducer(obj, key)
    return sum
  }, Object.create(null))
}
